// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__JEK5A","tab":"style_tab__T74-G"};